export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/threshold/sturges.js
// module id = BASm
// module chunks = 0